<template>
    <div class="meterConfigAccount-box">
        <div class="customerUsers-condition-box">
            <el-form :inline="true" :model="condition" size="mini">
                <el-form-item label="业主用户编号">
                    <el-input v-model="condition.name" style="width: 120px" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="业主用户名称">
                    <el-input v-model="condition.realName" style="width: 120px" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="手机">
                    <el-input v-model="condition.mobile" style="width: 120px" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="账户状态">
                    <el-select v-model="condition.enabled" style="width: 100px" size="mini">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="停用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="fetchCustomerUser" size="mini">查找</el-button>
                </el-form-item>
            </el-form>
        </div><!--筛选-->
        <!--<div class="div-hr"></div>-->
        <div class="op-box">
            <el-button size="mini" icon="el-icon-edit" type="primary" @click="addCustomerUserMeter" round>添加仪表</el-button>
            <el-button size="mini" icon="el-icon-delete" type="text" @click="removeCustomerUserMeter" style="color: #F56C6C">删除关联仪表</el-button>
            <!--<div style="float: right">
                <div class="opreation">
                    <div class="download">
                        <a href="/static/TenantMeterConfigurationTemplate.xlsx">仪表批量配置模版下载</a>
                    </div>&nbsp;&nbsp;&nbsp;&nbsp;
                    <div style="float: right">
                        <vue-xlsx-table @on-select-file="handleSelectedFile">
                            仪表批量配置信息上传
                        </vue-xlsx-table>
                    </div>
                </div>
            </div>-->
        </div><!--操作-->
        <div class="div-hr"></div>
        <div style="height: 100%">
            <div style="height: 48%">
                <flex>
                    <div class="customerUsers-table-box" style="height: 90%;">
                        <el-table class="customerUsers-table" size="small" stripe :data="customerUsers"
                                  height="100%" width="100%"
                                  highlight-current-row
                                  :header-row-style="{color:'black'}"
                                  @row-click="customerUserRowClick">
                            <el-table-column
                                    prop="realName"
                                    align="center"
                                    label="业主用户名称">
                            </el-table-column>
                            <el-table-column
                                    prop="name"
                                    align="center"
                                    label="业主用户编码">
                            </el-table-column>
                            <el-table-column
                                    prop="contactPerson"
                                    align="center"
                                    label="联系人">
                            </el-table-column>
                            <el-table-column
                                    prop="mobile"
                                    align="center"
                                    label="手机">
                            </el-table-column>
                            <el-table-column
                                    prop="email"
                                    align="center"
                                    label="电子邮箱">
                            </el-table-column>
                            <el-table-column
                                    prop="alarmReceivingMode"
                                    align="center"
                                    label="报警接收方式">
                                <template slot-scope="scope">
                                    <span>{{ receivingModeMap[scope.row.alarmReceivingMode] }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="enabled"
                                    align="center"
                                    label="账户状态">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.enabled === 1 ? '启用': '停用' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createDate"
                                    align="center"
                                    label="创建日期">
                                <template slot-scope="scope">
                                    <span>{{ formatTime(scope.row.createDate) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="deadline"
                                    align="center"
                                    label="有效截止日期">
                                <template slot-scope="scope">
                                    <span>{{ formatTime(scope.row.deadline) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="address"
                                    align="center"
                                    label="用户地址">
                            </el-table-column>
                            <el-table-column
                                    prop="note"
                                    align="center"
                                    label="备注">
                            </el-table-column>
                        </el-table>
                    </div><!--展示-->
                    <div class="page-box">
                        <el-pagination
                                background
                                @size-change="customerUserSizeChange"
                                @current-change="customerUserCurrentChange"
                                :current-page="customerUserPage.current"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="customerUserPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="customerUserPage.total">
                        </el-pagination>
                    </div><!--分页-->
                </flex>
            </div>
            <div class="div-hr"></div>
            <div style="height: 50%">
                <flex>
                    <div class="meter-table-box" style="height: 90%">
                        <el-table :data="meter" :header-row-style="{color:'black'}" size="mini"
                                  height="100%" width="100%"
                                  highlight-current-row
                                  stripe
                                  @row-click="meterRowClick">
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="仪表名称">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="code"
                                    label="仪表编号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterNum"
                                    label="表号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterTypeId"
                                    label="仪表型号">
                                <template slot-scope="scope">
                                    <span>{{ formatMeterType(scope.row.meterTypeId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="customerEnergyId"
                                    label="能源类型">
                                <template slot-scope="scope">
                                    <span>{{ formatCustomerEnergy(scope.row.customerEnergyId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="chargingPriceId"
                                    label="当前计费价格">
                                <template slot-scope="scope">
                                    <span>{{ formatChargingPrice(scope.row.chargingPriceId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="nextChargingPriceId"
                                    label="预制计费价格">
                                <template slot-scope="scope">
                                    <span>{{ formatChargingPrice(scope.row.nextChargingPriceId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterMoney.alarmMoney"
                                    label="预警金额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.alarmMoney == null ? '--' : returnFloat(scope.row.meterMoney.alarmMoney) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterMoney.overdraftMoney"
                                    label="可透支金额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.overdraftMoney == null ? '--' : returnFloat(scope.row.meterMoney.overdraftMoney) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterMoney.hoardMoney"
                                    label="可囤积金额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.hoardMoney == null ? '--' : returnFloat(scope.row.meterMoney.hoardMoney) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterMoney.isCutoutOfArrear"
                                    label="欠费跳闸">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.isCutoutOfArrear == null ? '--' : scope.row.meterMoney.isCutoutOfArrear == 1 ? '是' : '否' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="balance"
                                    label="当前余额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.balance == null ? '--': returnFloat(scope.row.balance) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center">
                                <template slot-scope="scope">
                                    <svg-icon icon-class="setting" style="width:1.2em; height: 1.2em"></svg-icon><el-button type="text" size="mini" @click="meterConfig(scope.row)">配置仪表</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column align="center">
                                <template slot-scope="scope">
                                <span v-if="scope.row.accountStatus === 0">
                                    <el-button type="text" size="mini" @click="openningAccount(scope.row)">开户</el-button>
                                </span>
                                <span v-else>
                                    <el-button type="text" size="mini" @click="stoppingAccount(scope.row)" style="color: #F56C6C">停用</el-button>
                                </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div><!--展示-->
                    <div class="page-box">
                        <el-pagination
                                background
                                @size-change="meterSizeChange"
                                @current-change="meterCurrentChange"
                                :current-page="meterPage.current"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="meterPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="meterPage.total">
                        </el-pagination>
                    </div><!--分页-->
                </flex>
            </div>
        </div>
        <el-dialog :visible.sync="meterConfigDialogVisible" width="50rem" top="15vh" size="small">
            <template slot="title">
                配置仪表
            </template>
            <div style="display: flex; justify-content: center">
                <el-form ref="meterConfigForm" :model="meterConfigInfo" :rules="meterConfigRules" label-width="10rem" size="small">
                    <div class="item-group">
                        <el-form-item label="仪表名称" prop="name">
                            <el-input v-model="meterConfigInfo.name" disabled style="width: 12rem"></el-input>
                        </el-form-item>
                        <el-form-item label="仪表编码" prop="code">
                            <el-input v-model="meterConfigInfo.code" disabled style="width: 12rem"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item-group">
                        <el-form-item label="表号" prop="meterNum">
                            <el-input v-model="meterConfigInfo.meterNum" disabled style="width: 12rem"></el-input>
                        </el-form-item>
                        <el-form-item label="使能欠费跳闸" prop="isCutoutOfArrear" :rules="[ meterConfigInfo.meterTypeId === '2d49e0b5-f37d-11e8-9c8f-0235d2b38928' || meterConfigInfo.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b' ? {} : { required: true, message: '使能欠费跳闸必选'}]">
                            <el-select v-model="meterConfigInfo.isCutoutOfArrear" placeholder="请选择" style="width: 12rem" :disabled="meterConfigInfo.meterTypeId === '2d49e0b5-f37d-11e8-9c8f-0235d2b38928' || meterConfigInfo.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b'">
                                <el-option label="否" :value="0"></el-option>
                                <el-option label="是" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="item-group">
                        <el-form-item label="预制计费价格" prop="nextChargingPriceId">
                            <el-select v-model="meterConfigInfo.nextChargingPriceId" placeholder="请选择"  style="width: 12rem">
                                <el-option label="无" :value="null"></el-option>
                                <el-option v-for="chargingPrice in chargingPrices" :key="chargingPrice.id" :disabled="(chargingPrice.customerEnergyId !== meterConfigInfo.customerEnergyId) || ((meterConfigInfo.meterTypeId == '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b' || meterConfigInfo.meterTypeId == '69e51132-fefb-5b60-b5a8-9164176467d8' || meterConfigInfo.meterTypeId == '2d49e0b5-f37d-11e8-9c8f-0235d2b38928') & chargingPrice.type === 0)"
                                           :label="chargingPrice.name" :value="chargingPrice.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="预警金额（元）" prop="alarmMoney">
                            <el-input v-model="meterConfigInfo.alarmMoney" style="width: 12rem"></el-input>
                        </el-form-item>
                    </div>
                    <div class="item-group">
                        <el-form-item label="可透支金额（元）" prop="overdraftMoney">
                            <el-input v-model="meterConfigInfo.overdraftMoney" style="width: 12rem"></el-input>
                        </el-form-item>
                        <el-form-item label="可囤积金额（元）" prop="hoardMoney">
                            <el-input v-model="meterConfigInfo.hoardMoney" style="width: 12rem"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="meterConfigDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="meterConfigSave" size="small">保存</el-button>
            </span>
        </el-dialog><!--弹窗-->
        <el-dialog :visible.sync="addMeterDialogVisible" width="40rem" top="15vh" size="small">
            <template slot="title">
                添加仪表
            </template>
            <div style="display: flex; justify-content: center">
                <el-form ref="addMeterForm" :model="customerUserMeter" :rules="meterIdsRules" label-width="6rem" size="small" >
                    <el-form-item label="选择仪表" prop="meterIds" align="center">
                        <el-select v-model="customerUserMeter.meterIds" placeholder="请选择" multiple filterable>
                            <el-option v-for="meter in meters" :key="meter.id"
                                       :label="meter.name" :value="meter.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addMeterDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="saveCustomerUserMeter" size="small">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="removeDialogVisible" width="40rem" top="15vh" size="small">
            <template slot="title">
                删除提示
            </template>

            <div style="display: flex; justify-content: center">
                删除后用户数据会丢失，确定删除吗？
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="removeDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="deleteCustomerUserMeter" size="small">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="openningAccountDialogVisible" width="90rem" top="30vh" size="small">
            <template slot="title">
                开户操作
            </template>
            <div style="display: flex; flex-direction: column; justify-content: center">
                <div>
                    <el-form :model="selectedCustomerUser" :inline="true" size="mini">
                        <el-form-item label="业主用户名称">
                            <el-input v-model="selectedCustomerUser.realName" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="业主用户编码">
                            <el-input v-model="selectedCustomerUser.name" disabled></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <el-table :data="openningAccountMeter" :header-row-style="{color:'black'}" size="mini" width="100%">
                        <el-table-column
                                align="center"
                                prop="name"
                                label="仪表名称">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="code"
                                label="仪表编号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterNum"
                                label="表号">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterTypeId"
                                label="仪表型号">
                            <template slot-scope="scope">
                                <span>{{ formatMeterType(scope.row.meterTypeId) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="customerEnergyId"
                                label="能源类型">
                            <template slot-scope="scope">
                                <span>{{ formatCustomerEnergy(scope.row.customerEnergyId) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="chargingPriceId"
                                label="当前计费价格">
                            <template slot-scope="scope">
                                <span>{{ formatChargingPrice(scope.row.chargingPriceId) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="nextChargingPriceId"
                                label="预制计费价格">
                            <template slot-scope="scope">
                                <span>{{ formatChargingPrice(scope.row.nextChargingPriceId) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterMoney.alarmMoney"
                                label="预警金额（元）">
                            <template slot-scope="scope">
                                <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.alarmMoney == null ? '--' : returnFloat(scope.row.meterMoney.alarmMoney) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterMoney.overdraftMoney"
                                label="可透支金额（元）">
                            <template slot-scope="scope">
                                <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.overdraftMoney == null ? '--' : returnFloat(scope.row.meterMoney.overdraftMoney) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterMoney.hoardMoney"
                                label="可囤积金额（元）">
                            <template slot-scope="scope">
                                <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.hoardMoney == null ? '--' : returnFloat(scope.row.meterMoney.hoardMoney) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterMoney.isCutoutOfArrear"
                                label="欠费跳闸">
                            <template slot-scope="scope">
                                <span>{{ scope.row.meterMoney == null ? '--' : scope.row.meterMoney.isCutoutOfArrear == null ? '--' : scope.row.meterMoney.isCutoutOfArrear == 0 ? '否' : '是' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="balance"
                                label="当前余额（元）">
                            <template slot-scope="scope">
                                <span>{{ scope.row.balance == null ? '--': returnFloat(scope.row.balance) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openningAccountDialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="openningAccountConfirm" size="small">确认开户</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="stoppingAccountDialogVisible" width="70rem" top="30vh" size="small">
            <template slot="title">
                停用操作
            </template>
            <div style="display: flex; flex-direction: column; justify-content: center">
                <div>
                    <el-form :model="selectedCustomerUser" :inline="true" size="mini">
                        <el-form-item label="业主用户名称">
                            <el-input v-model="selectedCustomerUser.realName" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="业主用户编码">
                            <el-input v-model="selectedCustomerUser.name" disabled></el-input>
                        </el-form-item>
                        <el-form-item>
                            注：欠费仪表不能直接报停，请补交费用至0以上
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <div>
                        <el-table :data="stoppingAccountMeter" :header-row-style="{color:'black'}" size="mini" width="100%">
                            <el-table-column
                                    align="center"
                                    prop="name"
                                    label="仪表名称">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="code"
                                    label="仪表编号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterNum"
                                    label="表号">
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="meterTypeId"
                                    label="仪表型号">
                                <template slot-scope="scope">
                                    <span>{{ formatMeterType(scope.row.meterTypeId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="customerEnergyId"
                                    label="能源类型">
                                <template slot-scope="scope">
                                    <span>{{ formatCustomerEnergy(scope.row.customerEnergyId) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    align="center"
                                    prop="balance"
                                    label="当前余额（元）">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.balance == null ? '--': scope.row.balance }}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="float: right; font-size: 1.2rem; padding-top: 1rem" v-if="stoppingAccountMeter.length > 0">
                        应退金额：<span style="font-size: 1.2rem; font-weight: bold;">{{ returnFloat(stoppingAccountMeter[0].balance) }}</span> 元
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="stoppingAccountDialogVisible = false" size="small">取消</el-button>
                <!--<el-tooltip content="保电模式下，仪表不会因欠费而跳闸。" placement="top" effect="light"></el-tooltip>-->
                <el-button type="primary" @click="stoppingAccountConfirm" size="small" :disabled="judgeButton">
                    确认停用
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>/
<script>
    import { mapGetters } from 'vuex'
    import { Message } from 'element-ui'
    import { getCustomerUsers } from '@/api/customerUser'
    import {  formatToDay } from '@/utils/time'
    import { getCustomerUserMeter, saveMeterInfo, fetchMetersNotInUser, saveCustomerUserMeter, deleteUserMeter, openningAccount,
      stoppingAccount, batchConfig } from "@/api/meterConfigAccount"
    import { getCustomerEenrgies } from "@/api/customerEnergy"
    import { getMeterType } from "@/api/meterType"
    import { getChargingByCustomerId } from "@/api/ChargingPrice"
    import { amountRegex } from '@/utils/validate'
    import { uuidWithoutLine } from "@/utils/uuid"
    import { WS } from '@/utils/ws'
    import Flex from "@/components/Flex";
    import { selectRoleByCode } from "@/api/customerRole"
    import { getSortFun } from "@/utils/arrayUtils"
    import {electricityId} from "../../../../config/config";

    export default {
        name: 'meterConfigAccount',
      components: {Flex},
      data() {
        var validateAlarmAmount = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('预警金额必填'))
          } else {
            if(!amountRegex.test(value)){
              callback(new Error("请输入正确的金额"))
            }else {
              if (this.meterConfigInfo.hoardMoney === '') {
                callback(new Error('囤积金额必填'))
              } else {
                if (parseFloat(value) > parseFloat(this.meterConfigInfo.hoardMoney)) {
                  callback(new Error('预警金额不能大于可囤积金额'))
                } else {
                  callback()
                }
              }
            }
          }
        }
        var validateOverdraftAmount = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('透支金额必填'))
          } else {
            if(!amountRegex.test(value)){
              callback(new Error("请输入正确的金额"))
            }else{
              if (this.meterConfigInfo.hoardMoney === '') {
                callback(new Error('囤积金额必填'))
              }else{
                if(parseFloat(value) > parseFloat(this.meterConfigInfo.hoardMoney)){
                  callback(new Error('透支金额不能大于可囤积金额'))
                }else{
                  callback()
                }
              }
            }
          }
        }
            return{
              loading:true,
              customerUserPage: {}, /* 分页对象*/
              meterPage: {}, /* 分页对象*/
              customerUserCurrentPage: 1,
              customerUserPageSize: 10,
              meterCurrentPage: 1,
              meterPageSize: 10,
              condition: {
                    customerId: null,
                    userType: 1,
                    name: null,
                    realName: null,
                    mobile: null,
                    enabled: null,
                    customerRoleId: null//业主用户角色id
                },
              receivingModeMap: {
                    0: '不接收',
                    1: '短信',
                    2: '邮件',
                    3: '短信+邮件'
                },
              customerUsers: [],
              selectedCustomerUser: [],
              selectedCustomerUserTemp: [],
              meter: [],
              customerEnergies:[],
              meterType: [],
              chargingPrices: [],
              selectedMeter: {},
              meterConfigDialogVisible: false,
              meterConfigRules: {
                /*chargingPriceId: [{ required: true, message: '当前计费价格必选', trigger: 'change' }],*/
                //nextChargingPriceId: [{ required: true, message: '预制计费价格必选', trigger: 'change' }],
                alarmMoney: [{ validator: validateAlarmAmount, trigger: 'blur' },{ required: true, message: '预警金额必填', trigger: 'blur' }/*{ pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }*/],
                overdraftMoney: [{ validator: validateOverdraftAmount, trigger: 'blur' },{ required: true, message: '可透支金额必填', trigger: 'blur' }/*{ pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }*/],
                hoardMoney: [{ required: true, message: '可囤积金额必填', trigger: 'blur' }, { pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' }],
                //isCutoutOfArrear: [{ required: true, message: '使能欠费跳闸必选', trigger: 'change' }]
              },
              meterConfigInfo: {},
              meters: [],
              customerUserMeter: {},
              addMeterDialogVisible: false,
              meterIdsRules: {
                  meterIds: [{ required: true, message: '仪表必选', trigger: 'change' }]
              },
              removeDialogVisible: false,
              openningAccountDialogVisible: false,
              openningAccountMeter: [],
              stoppingAccountDialogVisible: false,
              stoppingAccountMeter: [],
              judgeButton: false,
              openAnAccountSubscribe: {},//开户订阅对象
              refundSubscribe: {},//停用订阅对象
              amountSettingSubscribe: {},
              writeAlarmValSubscribe: {},
              rateSettingSubscribe: {},
              controlAvailableSubscribe: {}
            }
        },
        computed: {
          ...mapGetters([
            'customerId',
            'userId'
          ])
        },
        mounted() { /* 页面初始化完成加载数据*/
          //this.customerUserPage.size = 20
          this.fetchCustomerUser()
          this.fetchCustomerEnergies()
          this.fetchMeterType()
          this.fetchChargingPrice()
          //this.fetchMetersNotInUser()
          let me = this
          this.subscribe()


        },
      destroyed() {
        if (this.openAnAccountSubscribe && this.openAnAccountSubscribe.connected) {
          this.openAnAccountSubscribe.disconnect()
        }
        if (this.refundSubscribe && this.refundSubscribe.connected) {
          this.refundSubscribe.disconnect()
        }
        if (this.rateSettingSubscribe && this.rateSettingSubscribe.connected) {
          this.rateSettingSubscribe.disconnect()
        }
        if (this.writeAlarmValSubscribe && this.writeAlarmValSubscribe.connected) {
          this.writeAlarmValSubscribe.disconnect()
        }
        if (this.amountSettingSubscribe && this.amountSettingSubscribe.connected) {
          this.amountSettingSubscribe.disconnect()
        }
        if (this.controlAvailableSubscribe && this.controlAvailableSubscribe.connected) {
          this.controlAvailableSubscribe.disconnect()
        }
      },
        methods: {
          subscribe: function(){

            this.controlAvailableSubscribe = new WS();
            this.controlAvailableSubscribe.connect(res => {
              this.controlAvailableSubscribe.subscribe("/topic/controlAvailable/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
                let result = JSON.parse(val.body)
                let meterName = result.meter.name
                var title = ''
                if(result.availableElectric === true){
                  title = '设置欠费不跳闸'
                }else{
                  title = '设置欠费跳闸'
                }
                if(result.code === 200){
                  this.$notify({
                    title: title,
                    message: '仪表：'+meterName+' ' +title+ '成功',
                    duration: 9000,
                    offset: 100,
                    type: 'success'
                  });
                  if(this.targetId !== ''){
                    if(this.targetId === result.meter.id){
                      this.meterInfo.meterMoney.isCutoutOfArrear = result.meter.meterMoney.isCutoutOfArrear
                    }
                  }
                }else{
                  this.$notify({
                    title: title,
                    message: '仪表：'+meterName+' ' +title+ '失败',
                    duration: 9000,
                    offset: 100,
                    type: 'error'
                  });
                }
                if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                  this.reloadMeterInfo(true)
                }
              })
            }, err => {

            })
            //WebSocket
            this.openAnAccountSubscribe = new WS();
            this.openAnAccountSubscribe.connect(res => {
              this.openAnAccountSubscribe.subscribe("/topic/openAnAccount/"+this.userId,(val) => {//开户订阅
                let result = JSON.parse(val.body)
                let meterName = result.meter.name
                let code = result.code
                if(code === 200 || code === 501){
                  this.$notify({
                    title: '开户',
                    message: '仪表['+meterName+']开户成功',
                    duration: 9000,
                    offset: 100,
                    type: 'success'
                  });
                }else{
                  let infoJson = result.infoJson
                  if(infoJson != null && typeof infoJson != 'undefined'){
                    if(infoJson.accountOpen){
                      this.$notify({
                        title: '开户',
                        message: '仪表['+meterName+']开户成功',
                        duration: 9000,
                        offset: 100,
                        type: 'success'
                      });
                    }else{
                      this.$notify({
                        title: '开户',
                        message: '仪表['+meterName+']开户失败；'+result.message,
                        duration: 9000,
                        offset: 100,
                        type: 'error'
                      });
                    }
                  }else{
                    this.$notify({
                      title: '开户',
                      message: '仪表['+meterName+']开户失败；'+result.message,
                      duration: 9000,
                      offset: 100,
                      type: 'error'
                    });
                  }
                }
                if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                  this.reloadMeterInfo(true)
                }
              })
            }, err => {

            })

            this.amountSettingSubscribe = new WS();
            this.amountSettingSubscribe.connect(res => {
              this.amountSettingSubscribe.subscribe("/topic/amountSetting/"+this.userId,(val) => {//金额设置订阅
                let result = JSON.parse(val.body)
                let meterName = result.meter.name
                if(result.code === 200){
                  this.$notify({
                    title: '透支、囤积金额设置',
                    message: '仪表['+meterName+']透支、囤积金额设置成功',
                    duration: 4500,
                    offset: 100,
                    type: 'success'
                  });
                }else{
                  this.$notify({
                    title: '透支、囤积金额设置',
                    message: '仪表['+meterName+']透支、囤积金额设置失败',
                    duration: 4500,
                    offset: 100,
                    type: 'error'
                  });
                }
                //延时，等待后台更新数据库
                setTimeout(() => {
                  if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                    this.reloadMeterInfo(true)
                  }
                }, 1000)
              })
            }, err => {

            })

            this.writeAlarmValSubscribe = new WS();
            this.writeAlarmValSubscribe.connect(res => {
              this.writeAlarmValSubscribe.subscribe("/topic/writeAlarmVal/"+this.userId, (val) => {//报警金额设置订阅
                let result = JSON.parse(val.body)
                let meterName = result.meter.name
                if(result.code === 200){
                  this.$notify({
                    title: '报警金额设置',
                    message: '仪表['+meterName+']报警金额设置成功',
                    duration: 4500,
                    offset: 100,
                    type: 'success'
                  });
                }else{
                  this.$notify({
                    title: '报警金额设置',
                    message: '仪表['+meterName+']报警金额设置失败',
                    duration: 4500,
                    offset: 100,
                    type: 'error'
                  });
                }
                //延时，等待后台更新数据库
                setTimeout(() => {
                  if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                    this.reloadMeterInfo(true)
                  }
                }, 1000)
              })
            }, err => {

            })

            this.refundSubscribe = new WS();
            this.refundSubscribe.connect(res => {
              this.refundSubscribe.subscribe("/topic/refund/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
                let message = JSON.parse(val.body)
                let result = message.result
                let infoMessage = message.message
                if (result.status == 2) {   //充值成功
                  this.$notify({
                    title: '停用',
                    dangerouslyUseHTMLString: true,
                    message: '<span>仪表['+result.meter_name+']停用成功</span><br><span style="font-size: 1rem;">应退金额：<span style="font-size: 1.2rem; font-weight: bold;">' + this.returnFloat(result.pre_balance) + '</span>元</span>',
                    duration: 0,
                    offset: 100,
                    type: 'success'
                  });
                }else if(result.status == 1 || result.status == 5){
                  this.$notify({
                    title: '停用',
                    message: '仪表['+result.meter_name+']停用失败；失败原因：' + infoMessage,
                    duration: 4500,
                    offset: 100,
                    type: 'error'
                  });
                } else {
                  this.$notify({
                    title: '停用',
                    message: '仪表['+result.meter_name+']停用异常；失败原因：' + infoMessage + "，请在稍后核对仪表余额。",
                    duration: 4500,
                    offset: 100,
                    type: 'warning'
                  });
                }
                if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                debugger
                  this.reloadMeterInfo(true)
                }
              })
            }, err => {

            })

            this.rateSettingSubscribe = new WS();
            this.rateSettingSubscribe.connect(res => {
              this.rateSettingSubscribe.subscribe("/topic/rateSetting/"+this.userId, (val) => {//读取仪表参数订阅，若接收到内容，因报停调用的读取仪表参数内容更新信息
                let result = JSON.parse(val.body)
                let meterName = result.meter.name
                if(result.code === 200){
                  if (result.errorStatus !== null && result.errorStatus === 0) {
                    this.$notify({
                      title: '费率设置',
                      message: '仪表['+meterName+']计费价格下发成功',
                      duration: 4500,
                      offset: 100,
                      type: 'success'
                    });
                  }else{
                    this.$notify({
                      title: '费率设置',
                      message: '仪表['+meterName+']计费价格下发失败；错误状态字[' + result.errorStatus + "]；" + result.message,
                      duration: 4500,
                      offset: 100,
                      type: 'error'
                    });
                  }
                }else if(result.code === 501){
                  this.$notify({
                    title: '费率设置',
                    message: '仪表['+meterName+']计费价格下发成功；状态码[' + result.code + ']',
                    duration: 4500,
                    offset: 100,
                    type: 'success'
                  });
                }else{
                  this.$notify({
                    title: '费率设置',
                    message: '仪表['+meterName+']计费价格下发失败；状态码[' + result.code + ']；' + (result.code == 502 ? '写命令失败；' : '') + result.message,
                    duration: 4500,
                    offset: 100,
                    type: 'error'
                  });
                }
                if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                debugger
                  this.reloadMeterInfo(true)
                }
              })
            }, err => {

            })
          },
          handleSelectedFile (convertedData) {
            //校验文件属性完整
            const variableArr = ['customerCode','customerUserCode','meterCode','priceCode','isCutoutOfArrear','alarmMoney','overdraftMoney','hoardMoney']
            const object = convertedData.body[0]
            debugger
            let flag = true
            variableArr.forEach(variable => {
              if(!object.hasOwnProperty(variable)){
                Message({
                  message: '文件信息不完整',
                  type: 'error',
                  duration: 5 * 1000
                })
                flag = false
                return
              }
            })
            if(!flag)return
            //去掉第一个对象
            convertedData.body.splice(0, 1)
            var _data = convertedData.body

            if(typeof _data !== 'undefined' && _data !== null && _data.length > 1000){
              Message({
                message: '配置记录大于1000，请分开配置',
                type: 'error',
                duration: 5 * 1000
              })
              return
            }

            if(typeof _data !== 'undefined' && _data !== null && _data.length > 0){
              for(var j = 0 ; j < _data.length ; j ++ ){
                _data[j].isCutoutOfArrear === "是" ? _data[j].isCutoutOfArrear = 1 : _data[j].isCutoutOfArrear =0
              }
              //let map = {"customerId": this.customerId, "data": JSON.parse(_data)}
              batchConfig(this.customerId,_data).then(res => {
                if(res.code == 200){
                  let infoJson = res.infoJson
                  console.log(infoJson)
                  let content = "<table border='1' cellspacing='0' style='margin: auto; text-align: center;'><caption style='font-size: 26;'>批量仪表配置详情</caption><tr><th>业主用户 | 仪表</th><th>配置详情</th></tr>"

                  for (let key in infoJson){
                    content += "<tr><td>" + key.split("_")[0] + " | " + key.split("_")[1] + "</td><td>" + infoJson[key] + "</td></tr>"
                  }
                  content += "</table>"
                  this.$notify({
                    title: "仪表批量配置",
                    type: "success",
                    dangerouslyUseHTMLString: true,
                    duration: 0,
                    message: this.$createElement("div", null, [
                      this.$createElement("div", {
                        style: {
                          "margin-bottom": "5px",
                          "word-break": "break-all"
                        }
                      }, "配置仪表" + Object.keys(infoJson).length + "条记录"),
                      this.$createElement("button", {
                        style: {
                          "float": "right"
                        },
                        on: {
                          click: function () {
                            //打印账单
                            let newWindow = window.open("about:blank")
                            newWindow.document.write(content)
                            //newWindow.print();
                            //newWindow.close();
                          }
                        },
                        attrs: {
                          class: "el-button el-button--primary"
                        }
                      }, "查看配置详情")
                    ])
                  })
                }else{
                  Message({
                    message: res.message,
                    type: 'error',
                    duration: 5 * 1000
                  })
                }
              })
            }else{
              Message({
                message: '文件信息为空',
                type: 'error',
                duration: 5 * 1000
              })
            }
          },
          returnFloat: function(value) {
            var temp = Math.round(parseFloat(value) * 100) / 100
            var xsd = temp.toString().split('.')
            if (xsd.length === 1) {
              temp = (isNaN(temp) ? '0' : temp.toString()) + '.00'
              return temp
            }
            if (xsd.length > 1) {
              if (xsd[1].length < 2) {
                temp = temp.toString() + '0'
              }
              return temp
            }
          },
          stoppingAccountConfirm: function(){
            var uuid = uuidWithoutLine();
            var meter = this.stoppingAccountMeter[0]
            var customerUserId = this.userId
            var condition = {uuid: uuid, customerUserId: customerUserId, meter: meter}
            /*condition.uuid = uuid
            condition.customerUserId = customerUserId
            condition.meter = meter*/
            /*condition.set('uuid',uuid)
            condition.set('meter',meter)
            condition.set('customerUserId',customerUserId)*/
            //todo 改变仪表开户状态、开户时间、表底值、累计消费金额

            //todo 关闭能耗单元计算

            //todo 读取仪表参数更新仪表表
            stoppingAccount(condition).then(result => {//开户
              if(result.code === 200){
                Message({
                  message: result.message,
                  type: 'success',
                  duration: 5 * 1000
                })
                this.stoppingAccountDialogVisible = false
                this.stoppingAccountMeter = []
              }else{
                Message({
                  message: result.message,
                  type: 'warning',
                  duration: 5 * 1000
                })
              }
              if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
                this.reloadMeterInfo()
              }
            })

          },
          openningAccountConfirm: function(){
            var uuid = uuidWithoutLine();
            var meter = this.openningAccountMeter[0]
            var customerUserId = this.userId
            var condition = {uuid: uuid, customerUserId: customerUserId, meter: meter}
            /*condition.uuid = uuid
            condition.customerUserId = customerUserId
            condition.meter = meter*/
            /*condition.set('uuid',uuid)
            condition.set('meter',meter)
            condition.set('customerUserId',customerUserId)*/
            //console.log(condition)
            //开户前下发金额设置、费率设置
            /*console.log(condition)
            rateSetting(condition).then(r => {//费率设置
              if(r.code === 200){
                amountSetting(condition).then(res => {//金额设置
                  if(res.code === 200){*/
                    openningAccount(condition).then(result => {//开户
                      if(result.code === 200){
                        Message({
                          message: result.message,
                          type: 'success',
                          duration: 5 * 1000
                        })
                        this.openningAccountDialogVisible = false
                        this.openningAccountMeter = []
                      }else{
                        Message({
                          message: result.message,
                          type: 'warning',
                          duration: 5 * 1000
                        })
                      }
                    })
            /*if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
              this.reloadMeterInfo()
            }*/
            /*}else{
              Message({
                message: '金额设置失败',
                type: 'warning',
                duration: 5 * 1000
              })
            }
          })
        }else{
          Message({
            message: '费率设置失败',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      })*/
          },
          stoppingAccount: function(meter){
            if (typeof this.selectedCustomerUser.id === 'undefined' || this.selectedCustomerUser.id === null || this.selectedCustomerUser.id === '') {
              Message({
                message: '请选择业主用户',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            if (typeof meter.id === 'undefined' || meter.id === null || meter.id === '') {
              Message({
                message: '请选择仪表',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            this.judgeButton = false
            if(typeof meter.balance === 'undefined' || meter.balance === null || meter.balance === '' || meter.balance < 0)this.judgeButton = true
            debugger
            this.stoppingAccountMeter = [meter]
            //console.log(this.judgeButton)
            this.stoppingAccountDialogVisible = true
          },
          openningAccount: function(meter){
            if (typeof this.selectedCustomerUser.id === 'undefined' || this.selectedCustomerUser.id === null || this.selectedCustomerUser.id === '') {
              Message({
                message: '请选择业主用户',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            if (typeof meter.id === 'undefined' || meter.id === null || meter.id === '') {
              Message({
                message: '请选择仪表',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            //console.log(meter)
            this.openningAccountMeter = [meter]
            this.openningAccountDialogVisible = true
          },
          deleteCustomerUserMeter: function(){

            //删除时需要将对应能耗单元删除

            deleteUserMeter(this.selectedMeter).then(result => {
              if(result.code === 200){
                Message({
                  message: '操作成功',
                  type: 'success',
                  duration: 5 * 1000
                })
                this.removeDialogVisible = false
                this.selectedMeter = {}
                this.reloadMeterInfo()
              }else{
                Message({
                  message: '操作失败',
                  type: 'warning',
                  duration: 5 * 1000
                })
                this.removeDialogVisible = false
              }
            })
          },
          removeCustomerUserMeter: function(){
            if (typeof this.selectedMeter.id === 'undefined' || this.selectedMeter.id === null || this.selectedMeter.id === '') {
              Message({
                message: '请选择仪表',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }

            //删除前校验仪表开户状态
            if(this.selectedMeter.accountStatus === 1){
              Message({
                message: '仪表处于开户状态，不可删除！',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }

            this.removeDialogVisible = true
          },
          saveCustomerUserMeter: function(){//保存业主用户仪表关系

            //保存前校验业主用户有没有配置为能耗单元，若为能耗单元，则将需要配置的仪表也配置为它的子能耗单元

            this.$refs.addMeterForm.validate(valid => {
              if (valid) {
                this.customerUserMeter.customerUserId = this.selectedCustomerUser.id
                this.customerUserMeter.customerId = this.customerId
                //console.log(this.customerUserMeter)
                saveCustomerUserMeter(this.customerUserMeter).then(res => {
                  if(res.code === 200){
                    Message({
                      message: '操作成功',
                      type: 'success',
                      duration: 5 * 1000
                    })
                    //this.addMeterDialogVisible = false
                    this.reloadMeterInfo()
                    /*this.customerUserMeter = {meterIds: []}
                    this.selectedCustomerUser = {}*/
                  }else{
                    Message({
                      message: '操作失败',
                      type: 'warning',
                      duration: 5 * 1000
                    })
                  }
                  /*this.customerUserMeter = {meterIds: []}
                  this.selectedCustomerUser = {}*/
                  this.addMeterDialogVisible = false
                  this.customerUserMeter.meterIds = []
                })
              }
            })
          },
          reloadMeterInfo: function(isPage){
            if (!isPage) {
              this.meterPage['current'] = 1
            }
            const newPage = JSON.parse(JSON.stringify(this.meterPage))
            newPage.total = null
            const meterCondition = {id: this.selectedCustomerUser.id, customerId: this.customerId}
            const myPage = { page: newPage, condition: meterCondition }
            debugger
            this.fetchMeter(myPage)
          },
          addCustomerUserMeter: function(){
            if (typeof this.selectedCustomerUser.id === 'undefined' || this.selectedCustomerUser.id === null || this.selectedCustomerUser.id === '') {
              Message({
                message: '请选择业主用户',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            this.fetchMetersNotInUser()
            //console.log(this.customerUserMeter)
            if (this.$refs.addMeterForm) {
              this.$refs.addMeterForm.clearValidate()
            }
            this.addMeterDialogVisible = true
          },
          fetchMetersNotInUser: function(){//查询未配置关系的仪表
            var customerId = this.customerId
            fetchMetersNotInUser(customerId).then(res => {
              if(res.code === 200){
                  let temp = res.infoJson
                  temp.sort(getSortFun('asc','name'))
                this.meters = temp
              }
            })
          },
          meterConfigSave: function(){//保存仪表金额、费率信息
            this.$refs.meterConfigForm.validate(valid => {
              if (valid) {
                this.selectedMeter.nextChargingPriceId = this.meterConfigInfo.nextChargingPriceId
                this.selectedMeter.rateSendStatus = 0
                var meterMoneyTemp = {}
                if(typeof this.selectedMeter.meterMoney !== 'undefined' && this.selectedMeter.meterMoney !== null && this.selectedMeter.meterMoney !== ''){
                  meterMoneyTemp = this.selectedMeter.meterMoney
                }
                meterMoneyTemp['alarmMoney'] = this.meterConfigInfo.alarmMoney
                meterMoneyTemp['overdraftMoney'] = this.meterConfigInfo.overdraftMoney
                meterMoneyTemp['hoardMoney'] = this.meterConfigInfo.hoardMoney
                meterMoneyTemp['isCutoutOfArrear'] = this.meterConfigInfo.isCutoutOfArrear
                this.selectedMeter.meterMoney = meterMoneyTemp

                var meter = this.selectedMeter
                var customerUserId = this.userId
                var condition = { amountSettingUUID: uuidWithoutLine(), writeAlarmValUUID: uuidWithoutLine(), controlAvailableUUID: uuidWithoutLine(), customerUserId: customerUserId, meter: meter}

                saveMeterInfo(condition).then(res => {
                  let offset = 0
                    res.infoJson.forEach(result =>{
                      let code = result.split("||")[0]
                      let message = result.split("||")[1]
                      if (code == 200){
                        Message({
                          message: message,
                          type: 'success',
                          duration: 5 * 1000,
                          offset: offset
                        })
                      }else {
                        Message({
                          message: message,
                          type: 'warning',
                          duration: 5 * 1000,
                          offset: offset
                        })
                      }
                      offset += 55
                    })
                  this.selectedMeter = {}
                  this.meterConfigInfo = {}
                  this.meterConfigDialogVisible = false
                  if(typeof this.selectedCustomerUserTemp !== 'undenfind' && this.selectedCustomerUserTemp !== null){
                    if (this.meterPage.total) this.meterPage.total = null
                    const meterCondition = {id: this.selectedCustomerUserTemp.id, customerId: this.customerId}
                    const myPage = { page: this.meterPage, condition: meterCondition }
                    this.fetchMeter(myPage)
                    //this.selectedCustomerUserTemp = {}
                  }
                })
              }
            })
          },
          meterConfig: function(val){
            //重置
            this.meterConfigInfo = {}
            this.selectedMeter = Object.assign({},val)
            if (typeof this.selectedMeter.id === 'undefined' || this.selectedMeter.id === null || this.selectedMeter.id === '') {
              Message({
                message: '请选择仪表',
                type: 'warning',
                duration: 5 * 1000
              })
              return
            }
            var meterConfigInfoTemp = {}
            if(typeof this.selectedMeter.name !== 'undefined' && this.selectedMeter.name !== null){
              meterConfigInfoTemp['name'] = this.selectedMeter.name
            }
            if(typeof this.selectedMeter.code !== 'undefined' && this.selectedMeter.code !== null){
              meterConfigInfoTemp['code'] = this.selectedMeter.code
            }
            if(typeof this.selectedMeter.meterNum !== 'undefined' && this.selectedMeter.meterNum !== null){
              meterConfigInfoTemp['meterNum'] = this.selectedMeter.meterNum
            }
            if(typeof this.selectedMeter.chargingPriceId !== 'undefined' && this.selectedMeter.chargingPriceId !== null){
              meterConfigInfoTemp['chargingPriceId'] = this.selectedMeter.chargingPriceId
            }
            if(typeof this.selectedMeter.nextChargingPriceId !== 'undefined' && this.selectedMeter.nextChargingPriceId !== null){
              meterConfigInfoTemp['nextChargingPriceId'] = null
            }
            if(typeof this.selectedMeter.customerEnergyId !== 'undefined' && this.selectedMeter.customerEnergyId !== null){
              meterConfigInfoTemp['customerEnergyId'] = this.selectedMeter.customerEnergyId
            }
            if(typeof this.selectedMeter.meterTypeId !== 'undefined' && this.selectedMeter.meterTypeId !== null){
              meterConfigInfoTemp['meterTypeId'] = this.selectedMeter.meterTypeId
            }
            if(typeof this.selectedMeter.meterMoney !== 'undefined' && this.selectedMeter.meterMoney !== null){
              if(typeof this.selectedMeter.meterMoney.alarmMoney !== 'undefined' && this.selectedMeter.meterMoney.alarmMoney !== null){
                meterConfigInfoTemp['alarmMoney'] = this.selectedMeter.meterMoney.alarmMoney
              }
              if(typeof this.selectedMeter.meterMoney.overdraftMoney !== 'undefined' && this.selectedMeter.meterMoney.overdraftMoney !== null){
                meterConfigInfoTemp['overdraftMoney'] = this.selectedMeter.meterMoney.overdraftMoney
              }
              if(typeof this.selectedMeter.meterMoney.hoardMoney !== 'undefined' && this.selectedMeter.meterMoney.hoardMoney !== null){
                meterConfigInfoTemp['hoardMoney'] = this.selectedMeter.meterMoney.hoardMoney
              }
              if(typeof this.selectedMeter.meterMoney.isCutoutOfArrear !== 'undefined' && this.selectedMeter.meterMoney.isCutoutOfArrear !== null){
                meterConfigInfoTemp['isCutoutOfArrear'] = this.selectedMeter.meterMoney.isCutoutOfArrear
              }
            }
            this.meterConfigInfo = meterConfigInfoTemp;
            console.log(this.meterConfigInfo.meterTypeId)
            console.log('2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b')
            console.log(this.meterConfigInfo.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b')
            if (this.$refs.meterConfigForm) {
              this.$refs.meterConfigForm.clearValidate()
            }
            this.meterConfigDialogVisible = true
          },
          customerUserRowClick: function(val){//业主用户行点击事件
            this.selectedCustomerUser = Object.assign({}, val)
            if(typeof this.selectedCustomerUser !== 'undenfind' && this.selectedCustomerUser !== null){
              const customerUser = this.selectedCustomerUser
              this.selectedCustomerUserTemp = {}
              this.selectedCustomerUserTemp = customerUser
              this.reloadMeterInfo()
            }
          },
          meterRowClick: function(val){//仪表行点击事件
            this.selectedMeter = Object.assign({}, val)
          },
          fetchCustomerUser: function(isPage){//查询业主用户信息
                //筛选条件
            if (this.condition.name !== null && this.condition.name.length === 0) {
              this.condition.name = null
            }
            if (this.condition.realName !== null && this.condition.realName.length === 0) {
              this.condition.realName = null
            }
            if (this.condition.mobile !== null && this.condition.mobile.length === 0) {
              this.condition.mobile = null
            }

            const customerRole = { customerId: this.customerId, code: 'user', enabled: 1}
            selectRoleByCode(customerRole).then(result => {
              if(result.code === 200){
                const roles = result.infoJson
                if(typeof roles !== 'undefined' && roles !== null && roles.length > 0){
                  this.condition.customerRoleId = roles[0].id
                  //角色id
                  this.condition.customerRoleIds = [this.condition.customerRoleId]
                  //客户id
                  this.condition.customerId = this.customerId
                  if (this.customerUserPage.total) this.customerUserPage.total = null
                  const myPage = { page: this.customerUserPage, condition: this.condition }
                  if (!isPage) {
                    this.customerUserPage['current'] = 1
                  }
                  getCustomerUsers(myPage).then(res => {
                    if (res.code === 200) {
                      const customerUserPage = res.infoJson
                      this.customerUsers = customerUserPage.records
                      customerUserPage.records = null
                      this.customerUserPage.total = customerUserPage.total
                    }
                  }).catch(error => {
                    console.log(error)
                    return false
                  })
                }else{
                  Message({
                    message: '没有查询到相关业主用户角色！',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                }
              }else{
                Message({
                  message: '查询业主用户角色失败！',
                  type: 'warning',
                  duration: 5 * 1000
                })
              }
            })
          },
          fetchMeter: function(myPage){//按业主用户查询仪表信息
            getCustomerUserMeter(myPage).then(res => {
              if(res.code === 200){
                const meterPage = res.infoJson
                this.meter = meterPage.records
                this.meterPage.total = meterPage.total
              }else{
                Message({
                  message: '业主用户仪表查询失败',
                  type: 'warning',
                  duration: 5 * 1000
                })
                this.meter = []
                this.meterPage.total = 0
              }
            })
          },
          fetchCustomerEnergies: function () {//查询客户能源分类分项信息
            var customerId = this.customerId
            getCustomerEenrgies(customerId).then(res => {
              if(res.code === 200){
                this.customerEnergies =  res.infoJson
              }
            })
          },
          fetchMeterType: function () {//查询仪表类型信息
            const condition = {enabled: 1}
            getMeterType(condition).then(res => {
              if(res.code === 200){
                this.meterType =  res.infoJson
              }
            })
          },
          fetchChargingPrice: function () {//查询计费价格信息
            const condition = {customerId: this.customerId}
            getChargingByCustomerId(condition).then(res => {
              if(res.code === 200){
                this.chargingPrices =  res.infoJson
              }
            })
          },
          customerUserSizeChange: function(size) {
            this.customerUserPage.size = size
            this.customerUserPage.current = 1
            this.fetchCustomerUser(true)
          },
          customerUserCurrentChange: function(customerUserCurrentPage) {
            this.customerUserPage.current = customerUserCurrentPage
            this.fetchCustomerUser(true)
          },
          meterSizeChange: function(size) {
            this.meterPage.size = size
            this.meterPage.current = 1
            this.reloadMeterInfo(true)
          },
          meterCurrentChange: function(meterCurrentPage) {
            this.meterPage.current = meterCurrentPage
            this.reloadMeterInfo(true)
          },
          formatTime: function(time) {//格式化时间
            if (typeof time !== undefined && time !== null) {
              return formatToDay(time)
            } else {
              return time
            }
          },
          formatMeterType: function(meterTypeId) {//格式化仪表类型
            if (typeof meterTypeId !== 'undefined' && meterTypeId !== null && meterTypeId !== '') {
              if(typeof this.meterType !== 'undefined' && this.meterType !== null && this.meterType.length > 0){
                for(var i = 0; i < this.meterType.length; i ++){
                  if(meterTypeId === this.meterType[i].id){
                    return this.meterType[i].name
                  }
                }
              }
            } else {
              return '未知'
            }
          },
          formatCustomerEnergy: function(customerEnergyId) {//格式化能源分类分项
            if (typeof customerEnergyId !== 'undefined' && customerEnergyId !== null && customerEnergyId !== '') {
              if(typeof this.customerEnergies !== 'undefined' && this.customerEnergies !== null && this.customerEnergies.length > 0){
                for(var i = 0; i < this.customerEnergies.length; i ++){
                  if(customerEnergyId === this.customerEnergies[i].id){
                    return this.customerEnergies[i].name
                  }
                }
              }
            } else {
              return '未知'
            }
          },
          formatChargingPrice: function(chargingPriceId) {//格式化计费价格
            if (typeof chargingPriceId !== 'undefined' && chargingPriceId !== null && chargingPriceId !== '') {
              if(typeof this.chargingPrices !== 'undefined' && this.chargingPrices !== null && this.chargingPrices.length > 0){
                for(var i = 0; i < this.chargingPrices.length; i ++){
                  if(chargingPriceId === this.chargingPrices[i].id){
                    return this.chargingPrices[i].name
                  }
                }
              }
            } else {
              return '无'
            }
          },
        }
    }
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .meterConfigAccount-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }

        .customerUsers-condition-box {
            font-size: 14px;
            height: 60px;
            display: flex;
            align-items: center;
            padding-top: 15px;
            padding-left: 20px;
            box-sizing: border-box;
            .customer-User-search-button {
                margin-left: 10px;
            }
        }

        .div-hr {
            height: 1px;
            background-color: #dedede;
        }

        .op-box {
            padding-left: 20px;
            padding-top: 15px;
            padding-bottom: 15px;

            button {
                margin-right: 20px;
            }
        }

        .customerUsers-table-box {
            flex:1;
        }

        .meter-table-box {
            flex:1;
        }

        .page-box {
            //height: 45px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .item-group {
            display: flex;
            div {
                padding-right: 20px;
            }
        }


    }
</style>
<style>
    .el-dialog {
        background: #f6f7f7 !important;
    }
    .xlsx-button {
        display: inline-block !important;
        line-height: 1 !important;
        white-space: nowrap !important;
        cursor: pointer !important;
        border: 0.0625rem solid #00A5B2 !important;
        -webkit-appearance: none !important;
        text-align: center !important;
        box-sizing: border-box !important;
        outline: 0 !important;
        margin: 0 !important;
        transition: .1s !important;
        padding: 7px 9px !important;
        font-size: 0.75rem !important;
        font-weight: bold !important;
        border-radius: 0.25rem !important;
        /*color: #fff !important;*/
        background-color: #00A5B2 !important;
    }
    .download {
        display: inline-block ;
        line-height: 1 ;
        white-space: nowrap ;
        cursor: pointer ;
        border: 0.0625rem solid #00A5B2 ;
        -webkit-appearance: none ;
        text-align: center ;
        box-sizing: border-box ;
        outline: 0 ;
        margin: 0 ;
        transition: .1s ;
        padding: 7px 9px ;
        font-size: 0.75rem ;
        font-weight: bold ;
        color: #fff ;
        background-color: #00A5B2 ;
        border-radius: 4px;
    }
</style>
